import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useReactToPrint } from "react-to-print";

import { formatDate } from "../../components/utils/functions";
import IconPrint from "../../components/Icons/IconPrint";

import { Modal, Content, TextTitle, TextH, TextNegrita, Close, ContainerIconPrint, InfoPrint, Text } from "./styles";
import IconClose from "../../components/Icons/IconClose";

const ModalNoCapacityPay = ({ modalVisible, setModalVisible, firstName, createdDate }) => {
  const componentRef = useRef();
  const hoy = new Date().toISOString().split("T")[0];

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `Termino de capacidad de no pago ${firstName} ${hoy}`,
    removeAfterPrint: true,
  });

  return (
    modalVisible && (
      <Modal onClick={() => setModalVisible(false)}>
        <Content onClick={(event) => event.stopPropagation()}>
          <Close onClick={() => setModalVisible(false)}>
            <IconClose height={20} width={20} />
          </Close>
          <InfoPrint ref={componentRef}>
            <p style={{ marginTop: 20 }}>
              El/La señor(a) {firstName}, acepto el proximo termino el {formatDate(createdDate)}.
            </p>
            <TextTitle>
              <TextNegrita>AUTORIZACIÓN PARA NOTIFICACIÓN A TRAVÉS DE CORREO ELECTRÓNICO.</TextNegrita>
              <Text>
                Autorizo tanto al responsable como al encargado del tratamiento de datos personales para que utilice la
                dirección de mi correo electrónico para las notificaciones relacionadas con el proceso de Afiliación al
                Sistema General de Seguridad Social en Salud o actos administrativos que se puedan generar. En este
                sentido me obligo a operar de manera directa mi buzón de correo electrónico, informo que el correo
                suministrado es propio y por lo tanto no alegaré en ningún caso el desconocimiento de los actos
                notificados, informaré a la entidad los cambios de dirección de correo electrónico para el proceso de
                notificaciones electrónicas y reportar cualquier inconveniente de acceso al documento notificado.
              </Text>
              <TextNegrita>COMPROMISOS:</TextNegrita>
              <Text>
                En caso de ser <TextH>RETORNADO CON CÉDULA COLOMBIANA</TextH>: Me comprometo que una vez afiliado, debo
                solicitar la encuesta Sisbén de forma inmediata en el siguiente link (
                <a href="https://portalciudadano.sisben.gov.co/">https://portalciudadano.sisben.gov.co/</a>). y
                presentar el resultado de la misma dentro de los cuatro (04) meses siguientes a la afiliación al correo
                electrónico de la Secretaría de Salud del Municipio de mi residencia o de manera presencial en las
                taquillas.
              </Text>
              <Text>
                En caso de ser <TextH>MIGRANTE VENEZOLANO CON CÉDULA DE EXTRANJERÍA VIGENTE</TextH>: Me comprometo que
                una vez afiliado debo solicitar la encuesta Sisbén de forma inmediata en el siguiente link (
                <a href="https://portalciudadano.sisben.gov.co/">https://portalciudadano.sisben.gov.co/</a>). y
                presentar el resultado de la misma dentro de los cuatro (04) meses siguientes a la afiliación. *La
                información de los correos electrónicos podrá ser validada en el formulario que se encuentra
                diligenciando en el paso No. 4 y/o en el directorio de e-mail del home. Lo anterior, para efectos de la
                permanencia en el listado censal y en el Régimen Subsidiado.
              </Text>
              <Text>
                En caso de ser <TextH>MIGRANTE VENEZOLANO CON PEP VIGENTE</TextH>: Me comprometo que una vez afiliado
                debo solicitar la encuesta Sisbén de forma inmediata en el siguiente link (
                <a href="https://portalciudadano.sisben.gov.co/">https://portalciudadano.sisben.gov.co/</a>). y
                presentar el resultado de la misma dentro de los cuatro (04) meses siguientes a la afiliación, de igual
                manera me comprometo a acreditar mi permanencia en el país actualizando la información de mi domicilio
                cada cuatro (04) meses al correo electrónico de la Secretaría de Salud del Municipio de mi residencia o
                de manera presencial en las taquillas. Enviaré y/o entregaré fotocopia de la cuenta de servicios
                públicos u otro documento que acredite mi residencia. *La información de los correos electrónicos podrá
                ser validada en el formulario que se encuentra diligenciando en el paso No. 4 y/o en el directorio de
                e-mail del home. Lo anterior, para efectos de la permanencia en el listado censal y en el Régimen
                Subsidiado.
              </Text>
              <Text>
                <TextH>MIGRANTE VENEZOLANO CON PPT</TextH>: Me comprometo que una vez afiliado debo solicitar la
                encuesta Sisbén de forma inmediata en el siguiente link (
                <a href="https://portalciudadano.sisben.gov.co/">https://portalciudadano.sisben.gov.co/</a>). y
                presentar el resultado de la misma dentro de los cuatro (04) meses siguientes a la afiliación, de igual
                manera me comprometo a acreditar mi permanencia en el país actualizando la información de mi domicilio
                cada cuatro (04) meses al correo electrónico de la Secretaría de Salud del Municipio de mi residencia o
                de manera presencial en las taquillas. Enviaré y/o entregaré fotocopia de la cuenta de servicios
                públicos u otro documento que acredite mi residencia. *La información de los correos electrónicos podrá
                ser validada en el formulario que se encuentra diligenciando en el paso No. 4 y/o en el directorio de
                e-mail del home. Lo anterior, para efectos de la permanencia en el listado censal y en el Régimen
                Subsidiado.
              </Text>
              <Text>
                Para los <TextH>AFILIADOS TEMPORALMENTE SIN ENCUESTA SISBÉN</TextH>: Manifiesto que me ha informado que
                cuento con un plazo máximo de cuatro (04) meses para acreditar la aplicación de la encuesta SISBÉN, de
                lo contrario procederán con la terminación de la inscripción en la EPS.
              </Text>
              <TextNegrita>DECLARACIÓN DE NO CAPACIDAD DE PAGO:</TextNegrita>
              <Text>
                Declaro y manifiesto bajo la gravedad de juramento que no poseo capacidad de pago para afiliarme al
                Régimen Contributivo.
              </Text>
              <TextNegrita>AUTORIZACIONES PROCESO DE AFILIACIÓN TRANSACCIONAL:</TextNegrita>
              <Text>
                El proceso de afiliación transaccional requiere la validación de datos y aceptación de términos, por lo
                cual manifiesto mi autorización tanto al responsable como al encargado del tratamiento de datos
                personales para que, acepte estas autorizaciones en mi nombre a efecto de realizar la afiliación
                oficiosa al Régimen Subsidiado y adicionalmente, declaro de manera libre, expresa, inequívoca e
                informada, que autorizo al responsable de mis datos personales, para que, en los términos del literal a)
                del artículo 6 de la Ley 1581 de 2012, realice la recolección, almacenamiento, uso, circulación,
                supresión de mis datos personales sensibles, como lo son mis datos relacionados a mi estado general de
                salud, afiliación con grupos étnicos y LGBTIQ+, para que dicho tratamiento se realice con el objetivo de
                lograr las finalidades identificadas por la Entidad en torno al mejoramiento de la prestación de
                nuestros servicios. Se me ha informado que, como titular de datos personales sensibles, no estoy
                obligado a otorgar autorización sobre esta clase de datos; igualmente manifiesto que me han informado la
                posibilidad de escoger libremente la EAPB que quiero que administre mi plan de salud. Se señalan a
                continuación las autorizaciones y/o declaraciones:
              </Text>
              <Text>
                (*) Declaración de la no obligación de afiliarse al Régimen Contributivo, Especial o de Excepción
              </Text>
              <Text>
                (*) Autorización para que la EPS solicite y obtenga datos y copia de la historia clínica del cotizante o
                cabeza de familia y de sus beneficiarios o afiliados adicionales.
              </Text>
              <Text>
                (*) Autorización para que la EPS reporte la información que se genere de la afiliación del reporte de
                novedades a la base de datos de afiliados vigente y a las entidades públicas que por sus funciones la
                requieran. Autorización para que la EPS maneje los datos personales del cotizante o cabeza de familia y
                de sus beneficiarios o afiliados adicionales, de acuerdo con lo previsto en la Ley 1581 de 2012 y el
                Decreto 1377 de 2013. Autorización para que la EPS envíe información al correo electrónico o al celular
                como mensajes de texto.
              </Text>
              <Text>
                (*) Manifiesto la veracidad de la información registrada y de las declaraciones contenidas en el proceso
                de afiliación al Sistema General de Seguridad Social en Salud.
              </Text>
              <Text>
                (*) La entrega de la información pendiente en el proceso de afiliación podrá ser entregada y/o enviada
                al correo electrónico de la secretaria de salud de mi domicilio o de manera presencial en las taquillas.
              </Text>
              <Text>
                La información de los correos electrónicos podrá ser validada en el formulario que se encuentra
                diligenciando en el paso No. 4 y/o en el directorio de e-mail del home.
              </Text>
              <TextH style={{ marginTop: "20px" }}>
                Manifiesto que me han explicado el contenido de este documento, que lo he leído y entiendo y lo acepto y
                firmo en constancia de ello.
              </TextH>
            </TextTitle>
          </InfoPrint>
          {componentRef && (
            <ContainerIconPrint onClick={handlePrint}>
              <IconPrint />
            </ContainerIconPrint>
          )}
        </Content>
      </Modal>
    )
  );
};

ModalNoCapacityPay.propTypes = {
  modalVisible: PropTypes.bool,
  setModalVisible: PropTypes.func,
  firstName: PropTypes.string,
  createdDate: PropTypes.string,
};

export default ModalNoCapacityPay;
